var map = {
	"./app-icon.svg": 1730,
	"./caret-right-icon.svg": 1731,
	"./chrome-icon.webp": 1732,
	"./edge-icon.webp": 1733,
	"./firefox-icon.webp": 1734,
	"./opera-icon.webp": 1735,
	"./safari-icon.webp": 1736,
	"./unknown-icon.webp": 1737
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1729;